import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		DphSzbOzn: [],
		Pujcovna: [],
		StavplatbyPzn: [],
		ProvozovnaId: [],
	},
	edit: {
		SkodahlaspaId: null as number | null,
		VozidlopaId: null as number | null,
		OstatnipaId: null as number | null,
		ZakaznikId: null as number | null,
		PujcovnaId: null as number | null,
		ZodpovosJmeno: null as string | null,
		ZodpovosPrijmeni: null as string | null,
		ZodpovosTelefon: null as string | null,
		ZodpovosEMail: null as string | null,
		SkodaDat: null as Date | null,
		SkodaMisto: null as string | null,
		SkodaPopis: null as string | null,
		SkodaPc: null as number | null,
		SkodaUhradaDat: null as Date | null,
		Poznamka: null as string | null,
		StrednaklOzn: null as number | null,
		ProvozovnaId: null as number | null,
		DphSzbOzn: null as number | null,
		VstupDat: null as Date | null,
		VstupPracId: null as number | null,
		EditDat: null as Date | null,
		EditPracId: null as number | null,
		VyrazenDat: null as Date | null,
		PujcovnapaId: null as number | null,
		VrJmeno: null as string | null,
		VrPrijmeni: null as string | null,
		VrTelNr: null as string | null,
		VrEMailAdresa: null as string | null,
		DokladPfx: null as string | null,
		DokladNr: null as number | null,
		TiskDat: null as Date | null,
		StavplatbyPzn: null as number | null,
		SkodahlaspaNr: null as number | null,
		FakturaceDat: null as Date | null,
		VyrizenoDat: null as Date | null,
		EditPracIdText: null as string | null,
		VstupPracIdText: null as string | null,
		ProvozovnaIdText: null as string | null,
		ZakaznikIdText: null as string | null,
		VozidlopaSpz: null as string | null,
		StrednaklOznText: null as string | null,
		OstatnipaNr: null as string | null,
		OstatnipaText: null as string | null,
		VozidlopaKaroserieNr: null as string | null,
	},
	depTableNames: [],
	depTableSettings: {},
	localState: {},
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[editMutations.ZAPUJCKA_ZAKAZNIK_FILTER_SELECT_MAPPER](state, { data }) {
			state.edit.ZakaznikId = data.value;
			state.edit.ZakaznikIdText = data.text;
		},
		[editMutations.NAKLAD_STREDISKO_SELECT_MAPPER](state, { data }) {
			state.edit.StrednaklOzn = data.value;
			state.edit.StrednaklOznText = data.text;
			if (!data.isClear) {
				state.edit.ProvozovnaId = data.provozovnaId;
			}
		},
		[editMutations.ZAPUJCKA_VOZIDLO_FILTER_SELECT_MAPPER](state, { data }) {
			state.edit.VozidlopaId = data.id;
			state.edit.VozidlopaSpz = data.rzv;
			state.edit.VozidlopaKaroserieNr = data.vin;
		},
	},
	props: {
		filter: {
			FakturaceDatOd: null as string | null,
			FakturaceDatDo: null as string | null,
			VozidlopaId: null as string | null,
			OstatnipaId: null as string | null,
		},
		mode: null,
	},
});
